import { RenameDashboardProps } from '../../components/Dashboard/dashboardInterfaces';
import { displayToast } from '../../components/Toaster/displayToast';

const renameDashboardFetcher = async (
    surveyId: string,
    dashboardId: String,
    customDashboardTitle: RenameDashboardProps,
    successMessage: string,
    errorMessage: string,
    selectedSchema: string,
) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    myHeaders.append('X-Selected-Schema', selectedSchema);

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(customDashboardTitle),
    };

    return fetch(`${process.env.REACT_APP_API_URL}/survey/${surveyId}/dashboard/${dashboardId}/rename_dashboard`, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');

                return undefined;
            }
            displayToast(successMessage, 'success');

            return response.json();
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default renameDashboardFetcher;
